module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e01-4b74c2ae875c6e99fecbb4c6e1188912.jpg";